import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetBoardingCertificateResultEffect } from './get-boarding-certificate-result.effect';
import { getBoardingCertificateResultReducer } from './get-boarding-certificate-result.reducer';
import {
  GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME,
  GetBoardingCertificateResultState,
} from './get-boarding-certificate-result.state';

/** Token of the GetBoardingCertificateResult reducer */
export const GET_BOARDING_CERTIFICATE_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<GetBoardingCertificateResultState, Action>
>('Feature GetBoardingCertificateResult Reducer');

/** Provide default reducer for GetBoardingCertificateResult store */
export function getDefaultGetBoardingCertificateResultReducer() {
  return getBoardingCertificateResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_BOARDING_CERTIFICATE_RESULT_STORE_NAME, GET_BOARDING_CERTIFICATE_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetBoardingCertificateResultEffect]),
  ],
  providers: [
    {
      provide: GET_BOARDING_CERTIFICATE_RESULT_REDUCER_TOKEN,
      useFactory: getDefaultGetBoardingCertificateResultReducer,
    },
  ],
})
export class GetBoardingCertificateResultStoreModule {
  public static forRoot<T extends GetBoardingCertificateResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetBoardingCertificateResultStoreModule> {
    return {
      ngModule: GetBoardingCertificateResultStoreModule,
      providers: [{ provide: GET_BOARDING_CERTIFICATE_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
